<template>
	<div class="appPage">
		<video controls="controls" id="player" :src="videoPaly.src" :poster="videoPaly.poster" class="videos-player"
			autoplay>您的浏览器不支持video , 该更新浏览器了</video>
		<!-- <Back :linkTo="'/'" /> -->
	</div>
</template>

<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				ossLink: 'https://oss.eventnet.cn/H5/kwaiPlay/',
				videoPaly: {
					src: '',
					poster: ''
				}
			};
		},
		created() {
			const THAT = this;
			if (localStorage.getItem('video-kwai')) {
				let kwaiVideo = JSON.parse(localStorage.getItem('video-kwai'));
				THAT.videoPaly.src = kwaiVideo.address;
				THAT.videoPaly.poster = kwaiVideo.photo;
			} else {
				THAT.$router.replace('/Video').catch(err => err);
			}
		},
		methods: {},
		destroyed() {
			console.log('卸载后');
			localStorage.removeItem('video-kwai');
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.appPage {
		background: url('https://oss.eventnet.cn/H5/kwaiPlay/img/bg.jpg') no-repeat;
		background-size: 100% 100%;
		padding: 0 !important;
		overflow: hidden;

		&::after {
			height: 810px;
			background: url('https://oss.eventnet.cn/H5/kwaiPlay/img/bgFooter.png?v=2') no-repeat;
			background-size: 100% 100%;
		}

		.videos-player {
			position: relative;
			z-index: 2;
			width: 100vw;
			height: 100vh;
			background: #000;
		}
	}
</style>